import { Checkbox, Input, Select } from "antd";
import { useState } from "react";
import { svg } from "../../../../Assets/svg";
import { AprOutputType, calculateAll } from "./aprCalculations";
import {
  beamLevelsOptions,
  boltsOptions,
  connectionOptions,
  connectionStyleOptions,
  crossSectionOptions,
  heavyProfileOptionsForAll,
  heavyProfileOptionsForOption1,
  heavyProfileOptionsForOption2,
  loadTypeOptions,
  profileMenuOptions,
  profileOptionsForAll,
  profileOptionsForOption1,
  profileOptionsForOption2,
} from "./aprData";
import { generateExcel } from "./aprExcel";

const StdPalletRacking = () => {
  const [edit1, setEdit1] = useState("");
  const [edit2, setEdit2] = useState("");
  const [edit3, setEdit3] = useState("1.5");
  const [edit6, setEdit6] = useState("");
  const [edit7, setEdit7] = useState("");
  const [edit11, setEdit11] = useState("");
  const [edit12, setEdit12] = useState("");
  const [edit13, setEdit13] = useState("");
  const [popupmenu1, setPopupmenu1] = useState(1);
  const [optionsMenu, setOptionsMenu] = useState(1);
  const [popupmenu2, setPopupmenu2] = useState(1);
  const [popupmenu3, setPopupmenu3] = useState(1);
  const [popupmenu5, setPopupmenu5] = useState(1);
  const [popupmenu6, setPopupmenu6] = useState(1);
  const [popupmenu9, setPopupmenu9] = useState(1);
  const [popupmenu11, setPopupmenu11] = useState(1);
  const [popupmenu16, setPopupmenu16] = useState(1);
  const [reinforChecked, setReinforChecked] = useState(false);
  const [heavyChecked, setHeavyChecked] = useState(false);
  const [toExcel, setToExcel] = useState(false);
  const [out, setOut] = useState<AprOutputType | null>(null);
  const [warningsOpen, setWarningsOpen] = useState(false);

  const selectedProfileOptions =
    Number(optionsMenu) === 3
      ? profileOptionsForOption2
      : Number(optionsMenu) === 2
        ? profileOptionsForOption1
        : profileOptionsForAll;

  const selectedHeavyProfileOptions =
    Number(optionsMenu) === 3
      ? heavyProfileOptionsForOption2
      : Number(optionsMenu) === 2
        ? heavyProfileOptionsForOption1
        : heavyProfileOptionsForAll;

  const handleCalculate = () => {
    const enforcedEdit2 = toExcel ? "NaN" : edit2;

    const inputs = {
      edit1,
      edit2: enforcedEdit2,
      edit3,
      edit6,
      edit7,
      edit11,
      edit12,
      edit13,
      popupmenu1,
      popupmenu2,
      popupmenu3,
      popupmenu5,
      popupmenu6,
      popupmenu9,
      popupmenu11,
      popupmenu16,
      reinforChecked,
      heavyChecked,
      toExcel,
    };

    try {
      const result = calculateAll(inputs);
      setOut(result);
    } catch (err) {
      setOut({
        text2: "",
        text3: "0.00",
        warnings: ["Calculation failed. See console."],
        technical: null,
      } as AprOutputType);
    }
  };

  const handleDownloadExcel = () => {
    if (!out) return;
    const payload = {
      inputs: {
        Uprights: profileOptionsForAll?.find(
          (item) => item?.value === Number(popupmenu1),
        )?.label,
        "First Beam Level": edit1,
        "Joint Type": connectionOptions?.find(
          (item) => item?.value === popupmenu2,
        )?.label,
        "Bolts per ft": boltsOptions?.find((item) => item?.value === popupmenu3)
          ?.label,
        FOS: edit3,
        "Total Load on Racking": edit2,
        "Single Bay": connectionStyleOptions?.find(
          (item) => item?.value === popupmenu5,
        )?.label,
        "Beam Levels": popupmenu6 === 1 ? ">1" : "=1",
        Reinforcement: String(reinforChecked),
        "Use Heavier Uprights": String(heavyChecked),
        "Other Beam Spacings": edit12,
        "Total Load on Level": edit13,
        "Heavier Uprights": heavyProfileOptionsForAll?.find(
          (item) => item?.value === Number(popupmenu16),
        )?.label,
        "Cross-Beam Width": edit6,
        "Cross Section": crossSectionOptions?.find(
          (item) => item?.value === Number(popupmenu9),
        )?.label,
        Deflection: edit7,
        "Type of Loads": loadTypeOptions?.find(
          (item) => item?.value === popupmenu11,
        )?.label,
        "Young's Modulus (GPa)": edit11,
      },
      outputs: {
        "Frame Load (kg)": out.text3 || "0.00",
        "% Load Used": out.text10 || "0.00",
        "Max Beam Load (kg)": out.text22 || "0.00",
        "Deflection (mm)": out.text21 || "0.00",
      },
      warnings: out.warnings || [],
      technical: out.technical || {},
    };
    generateExcel(payload, "std_pallet_racking.xlsx");
  };

  const disabledWhenTFF = (extra = false) => toExcel || extra;

  return (
    <div className="p-4">
      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Uprights Options</label>
            <Select
              placeholder="Uprights Options"
              onChange={(e) => {
                setOptionsMenu(e);
                setPopupmenu1(1);
                setPopupmenu16(1);
              }}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={profileMenuOptions}
              value={optionsMenu}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Uprights</label>
            <Select
              key={selectedProfileOptions.length}
              placeholder="Uprights"
              onChange={(e) => setPopupmenu1(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
            >
              {selectedProfileOptions?.map((o) => (
                <Select.Option key={o.value}>{o.label}</Select.Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">First Beam Level (mm)</label>
          <Input
            name="first-beam-level"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit1}
            onChange={(e) => setEdit1(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Joint Type</label>
            <Select
              placeholder="Joint Type"
              onChange={(e) => setPopupmenu2(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={connectionOptions}
              value={popupmenu2}
            />
          </div>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Bolts per ft</label>
            <Select
              placeholder="Bolts per ft"
              onChange={(e) => setPopupmenu3(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={boltsOptions}
              value={popupmenu3}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">FOS (Factor of Safety)</label>
          <Input
            name="fos-input"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit3}
            onChange={(e) => setEdit3(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Total Load on Racking</label>
          <Input
            name="total-load"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={toExcel ? "NaN" : edit2}
            onChange={(e) => setEdit2(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Single Bay</label>
            <Select
              placeholder="Single Bay"
              onChange={(e) => setPopupmenu5(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={connectionStyleOptions}
              value={popupmenu5}
            />
          </div>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Beam Levels</label>
            <Select
              placeholder="Beam Levels"
              onChange={(e) => setPopupmenu6(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={beamLevelsOptions}
              value={popupmenu6}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff opacity-0 d-md-block d-none">Reinforcement</label>
          <Checkbox
            checked={reinforChecked}
            onChange={(e) => setReinforChecked(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            Reinforcement
          </Checkbox>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff opacity-0 d-md-block d-none">Use Heavier Uprights</label>
          <Checkbox
            checked={heavyChecked}
            onChange={(e) => setHeavyChecked(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            Use Heavier Uprights
          </Checkbox>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Other Beam Spacings</label>
          <Input
            name="beam-spacings"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit12}
            onChange={(e) => setEdit12(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Total Load on Level</label>
          <Input
            name="total-load-level"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit13}
            onChange={(e) => setEdit13(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Heavier Uprights</label>
            <Select
              key={selectedHeavyProfileOptions.length}
              disabled={!heavyChecked || disabledWhenTFF()}
              placeholder="Heavier Uprights"
              onChange={(e) => setPopupmenu16(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
            >
              {selectedHeavyProfileOptions?.map((o) => (
                <Select.Option key={o.value}>{o.label}</Select.Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Cross-Beam Width</label>
          <Input
            name="cross-beam-width"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit6}
            onChange={(e) => {
              setEdit6(e.target.value);
              setEdit7((Number(e.target.value) / 200).toString());
            }}
            placeholder="0"
            type="number"
          />
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Cross Section</label>
            <Select
              placeholder="Cross Section"
              onChange={(e) => setPopupmenu9(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
            >
              {crossSectionOptions?.map((o) => (
                <Select.Option key={o.value}>{o.label}</Select.Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Deflection</label>
          <Input
            name="deflection-input"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit7}
            onChange={(e) => setEdit7(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Type of Loads</label>
            <Select
              placeholder="Type of Loads"
              onChange={(e) => setPopupmenu11(e)}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={loadTypeOptions}
              value={popupmenu11}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Young's Modulus (GPa)</label>
          <Input
            name="youngs-modulus"
            className="form-control form-control-lg"
            disabled={disabledWhenTFF()}
            value={edit11}
            onChange={(e) => setEdit11(e.target.value)}
            placeholder="0"
            type="number"
          />
        </div>
      </div>
      <div className="row gy-3 page-form mb-3">
        <div className="col-md-auto">
          <button
            onClick={handleCalculate}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            CALCULATE NOW
          </button>
        </div>
        <div className="col-md-auto col-sm-6">
          <button
            onClick={handleDownloadExcel}
            disabled={!out}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            DOWNLOAD EXCEL
          </button>
        </div>
        <div className="col-md-auto col-sm-6">
          <button
            onClick={() => setWarningsOpen((s) => !s)}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            SHOW/HIDE WARNINGS
          </button>
        </div>
      </div>

      <hr className="opacity-100 mb-4" />

      <h3>Results</h3>
      {out ? (
        <div className="mt-3">
          <p className="custom-label">
            {out.text2 || "Frame Load (kg)"}: {out.text3 || "0.00"}
          </p>

          <p className="custom-label">
            {out.text9 || "% Load Used"}: {out.text10 || "0.00"}
          </p>

          <p className="custom-label">
            {out.text19 || "Max Beam Load (kg)"}: {out.text22 || "0.00"}
          </p>

          <p className="custom-label">
            {out.text20 || "Deflection (mm)"}: {out.text21 || "0.00"}
          </p>

          {warningsOpen && (
            <div className="border pt-3 px-3">
              <h5>⚠️ Structural Warnings</h5>
              <div>
                {Array.isArray(out.warnings) && out.warnings.length > 0 ? (
                  out.warnings.map((w, i) => {
                    const warningText = String(w).toUpperCase();
                    const isError =
                      warningText.includes("OVER LOADED") ||
                      warningText.includes("EXCEEDS");

                    return (
                      <p className="custom-label text-949494" key={i}>
                        {w}
                      </p>
                    );
                  })
                ) : (
                  <p className="custom-label text-949494">
                    No structural warnings detected for this configuration.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="custom-label text-949494">
          No results — press CALCULATE NOW.
        </p>
      )}
    </div>
  );
};

export default StdPalletRacking;
